import script from "./adminhome.vue?vue&type=script&setup=true&lang=js"
export * from "./adminhome.vue?vue&type=script&setup=true&lang=js"

import "./adminhome.vue?vue&type=style&index=0&id=eb53739e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb53739e"]])

export default __exports__